module.exports = __webpack_public_path__ + "img/ltkkids-2x.9c153e1.jpg";